import { createGlobalStyle } from 'styled-components';

// NOTE colors that existed with different definitions: lightRed, skyBlue

export const ThemeGlobalStyle = createGlobalStyle`
  body {
    --transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

    /*
     * Colors
     */
    --color-black: #000000;
    --color-white: #ffffff;

    /* primary */
    --color-brandBlue: #0d73d9;
    --color-brandGreen: #68bd53;
    --color-brandYellow: #f7c702;
    --color-skyBlue: #5dc2f1;
    --color-mediumSkyBlue: #009de6;
    --color-softBlue: #ebf6ff;
    --color-backgroundBlue: #f8fcff;

    /* secondary */
    --color-lightYellow: #FFF6D1;
    --color-lightRed: #ffedef;
    --color-lightSage: #dbfdd3;
    --color-lightPurple: #f5edff;

    /* grey matter */
    --color-backgroundGrey: #fbfbfb;
    --color-inputGrey: #f8f6f6;
    --color-calloutGrey: #f1f1f1;
    --color-selectionGrey: #e6e6e6;
    --color-elementGrey: #c4c8cc;
    --color-lightContentGrey: #717375;
    --color-mediumContentGrey: #484848;
    --color-darkContentGrey: #242424;

    /* alerts and actions */
    --color-hoverBlue: #0042c1;
    --color-decorativePlum: #645694;
    --color-brightPlum: #9b489b;
    --color-alertRed: #d0021b;
    --color-alertRedHover: #b40016;
    --color-tagLemonGreen: #7de963;
    --color-lemon: #f7fc26;
    --color-decorativePoppy: #ef444d;
  }
`;
